<template>
  <div class="advice4-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          @click="goBack"
          aria-label="Zurück"
        >←</button>
      </div>

      <span class="badge">Für deine Beratung</span>
      <h1 class="intro-title">Zusammenfassung zum Mitnehmen</h1>
      <p class="intro-text">
        Diese Übersicht kannst du speichern oder ausdrucken und zu einem Termin
        bei deinem Hausarzt oder einer Ernährungsberatung mitbringen.
      </p>

      <div class="summary-doc">

        <div class="doc-header">
          <p class="doc-eyebrow">Swiss Eating Quiz</p>
          <p class="doc-title">Ernährungsprofil</p>
          <p class="doc-meta">Datum: {{ today }} · Teilnehmer-ID: 1247-A8</p>
        </div>

        <div class="doc-section">
          <p class="doc-section-title">Gesamtscore</p>
          <p class="doc-score">{{ overallScore }} / {{ overallMax }}</p>
          <p class="doc-score-label">{{ verbalLabel }}</p>
        </div>

        <div class="doc-section">
          <p class="doc-section-title">Lebensmittelgruppen</p>
          <table class="doc-table">
            <tbody>
              <tr v-for="g in groups" :key="g.id">
                <td class="group-cell">
                  <span class="emoji">{{ g.emoji }}</span>{{ g.name }}
                </td>
                <td class="score-cell">{{ g.score }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="doc-section">
          <p class="doc-section-title">Auffälligkeiten</p>
          <ul class="doc-list">
            <li>Niedriger Konsum pflanzlicher Proteine (Hülsenfrüchte, Tofu)</li>
            <li>Anteil Vollkornprodukte ausbaufähig</li>
            <li>Fisch-Konsum unter wöchentlicher Empfehlung</li>
          </ul>
        </div>

        <div class="doc-section">
          <p class="doc-section-title">Stärken</p>
          <ul class="doc-list">
            <li>Regelmässiger Gemüse- und Früchtekonsum</li>
            <li>Gute Trinkgewohnheiten (Wasser, ungesüsster Tee)</li>
            <li>Ausgewogene Auswahl bei Milchprodukten</li>
          </ul>
        </div>

        <p class="doc-footer">
          Erstellt mit dem Swiss Eating Quiz · Berner Fachhochschule. Dies ist
          kein medizinisches Dokument und ersetzt keine professionelle Beratung.
        </p>
      </div>

      <div class="actions">
        <button class="action-button primary" @click="saveAsPdf">📄 Als PDF speichern</button>
        <button class="action-button" @click="emailSummary">✉ Per E-Mail</button>
      </div>

      <p class="placeholder-note">Beispieldaten. Die echte Zusammenfassung enthält die individuellen Ergebnisse.</p>

    </main>
  </div>
</template>

<script>
import { overallScore, overallMax, verbalLabel, groups } from '../_data/sampleResults.js';

const dateFmt = new Intl.DateTimeFormat('de-CH', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export default {
  name: 'Advice4',
  data() {
    return {
      overallScore,
      overallMax,
      verbalLabel,
      groups,
      today: dateFmt.format(new Date()),
    };
  },
  methods: {
    goBack() { this.$router.back(); },
    saveAsPdf() {
      window.print();
    },
    emailSummary() {
      // Placeholder — real implementation will call the backend.
    },
  },
};
</script>

<style scoped>
.advice4-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.advice4-wrap *,
.advice4-wrap *::before,
.advice4-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.badge {
  display: inline-block;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.intro-title {
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.25;
}

.intro-text {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 1.5rem;
  line-height: 1.6;
}

.summary-doc {
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 1.25rem;
  margin-bottom: 1.25rem;
  background: var(--color-bg-card);
}

.doc-header {
  border-bottom: 0.5px solid var(--color-border);
  padding-bottom: 12px;
  margin-bottom: 14px;
}

.doc-eyebrow {
  font-size: 11px;
  color: var(--color-text-tertiary);
  margin: 0 0 4px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.doc-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 4px;
}

.doc-meta {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 0;
}

.doc-section {
  margin-bottom: 14px;
}

.doc-section:last-of-type { margin-bottom: 0; }

.doc-section-title {
  font-size: 12px;
  color: var(--color-text-tertiary);
  margin: 0 0 6px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 500;
}

.doc-score {
  font-size: 28px;
  font-weight: 500;
  color: var(--color-text-primary);
  line-height: 1;
  margin: 0 0 4px;
}

.doc-score-label {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
}

.doc-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}

.doc-table td {
  padding: 6px 0;
  border-bottom: 0.5px solid var(--color-border);
}

.doc-table tr:last-child td {
  border-bottom: none;
}

.doc-table .group-cell {
  color: var(--color-text-primary);
}

.doc-table .group-cell .emoji {
  margin-right: 6px;
}

.doc-table .score-cell {
  text-align: right;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.doc-list {
  list-style: disc;
  padding-left: 18px;
  margin: 0;
}

.doc-list li {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  padding: 2px 0;
}

.doc-footer {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 0.5px solid var(--color-border);
  line-height: 1.5;
}

.actions {
  display: flex;
  gap: 8px;
  margin-bottom: 1rem;
}

.action-button {
  flex: 1;
  padding: 12px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-card);
  font-size: 13px;
  color: var(--color-text-primary);
  cursor: pointer;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.action-button:hover {
  background: var(--color-bg-muted);
}

.action-button.primary {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
}

.action-button.primary:hover {
  opacity: 0.9;
  background: var(--color-accent);
}

.placeholder-note {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 1rem;
  font-style: italic;
}
</style>
